import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BUTTON_SIZE } from '../utils/constants';

export const ToolButton = styled(Button)({
  minWidth: 0,
  height: BUTTON_SIZE, // line height + padding
  width: BUTTON_SIZE, // line height + padding
});
